export default __webpack_public_path__ + "static/media/map.d78b1d77.jpeg";